module.exports = __webpack_public_path__ + "static/grant-44f4b0d1c16460921665aa6b835da582.jpg";